const appSettings = {
    loginWidgetEsm: process.env.REACT_APP_LOGIN_WIDGET_ESM,
    loginWidget: process.env.REACT_APP_LOGIN_WIDGET,
    loginRedirect: process.env.REACT_APP_LOGIN_REDIRECT,
    appInsightsKey: process.env.REACT_APP_APP_INSIGHTS_KEY,
    idp: process.env.REACT_APP_IDP,
    identityServer: process.env.REACT_APP_IDP_ENDPOINT,
    clientId: process.env.REACT_APP_CLIENT_ID,
    scope: process.env.REACT_APP_SCOPE,
  };
  
  export default appSettings;
  